import { apiRequest } from '@/utils/apiRequest'
import { apiUrl, extractCollection } from '@/utils/apiUrl'

class ServiceEventRepository {
	async getServiceEventsByDate(date, scope = 'pending') {
		const url = apiUrl(`/world/api/service-events?date=${date}&scope=${scope}`)
		try {
			const response = await apiRequest({ url, method: 'GET', expect: 'json' })
			const data = response?.data ?? response
			return extractCollection(data)
		} catch (e) {
			console.error('Error fetching service events:', e)
			return []
		}
	}

	async claimServiceEvent({ serviceEventId, staffId }) {
		const url = apiUrl('/world/api/service-event/claim')
		try {
			const response = await apiRequest({
				url,
				method: 'POST',
				body: { serviceEventId, staffId },
				throwOnNonOk: false,
			})
			if (!response.ok) {
				return { result: -1, message: response?.data?.message || 'Error claiming service event' }
			}
			return response.data
		} catch (e) {
			console.error('Error claiming service event:', e)
			return { result: -1, message: e?.message || 'Error claiming service event' }
		}
	}
}

export const serviceEventRepository = new ServiceEventRepository()
